import { render, staticRenderFns } from "./BoxReceiveLog.vue?vue&type=template&id=c35862ec&scoped=true&"
import script from "./BoxReceiveLog.vue?vue&type=script&lang=js&"
export * from "./BoxReceiveLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35862ec",
  null
  
)

export default component.exports